import React, {FunctionComponent} from 'react';
import {useConfigContext, useInputContext} from 'Context';
import {Radio} from 'ui/_Shared';

export const AnwaltlicheLeistungen: FunctionComponent = () => {
    const {input, setInput} = useInputContext();
    const {seite2} = useConfigContext();

    return <Radio label={seite2.frage4.label}
                  value={!!input.anwaeltlicheLeistungen ? 'Ja' : 'Nein'}
                  onChangeHandler={value => setInput(input => ({...input, anwaeltlicheLeistungen: value === 'Ja'}))}
                  options={[{label: 'Ja', value: 'Ja'}, {label: 'Nein', value: 'Nein'}]}/>;
};